module.exports = __webpack_public_path__ + "static/media/arrow-up.19c91d29.svg";